module.exports = __webpack_public_path__ + "static/img/140.54ddbdb8.png";